{
  "projectId": "project-d82dde7b-f9d9-404c-8da",
  "appId": "1:1077591327405:web:4a574d3d9490838de8bc24",
  "apiKey": "AIzaSyB2OdXlRbh6J_H1ZfOAod8H8uJ95qdwDQk",
  "authDomain": "project-d82dde7b-f9d9-404c-8da.firebaseapp.com",
  "firestoreDatabaseId": "ai-studio-halakhascripture-8002de7e-5a25-461c-9ea9-32077d584c1e",
  "storageBucket": "project-d82dde7b-f9d9-404c-8da.firebasestorage.app",
  "messagingSenderId": "1077591327405",
  "measurementId": "",
  "oAuthClientId": "1077591327405-tlplr1b3594mjifreareh55p2t8bk22r.apps.googleusercontent.com",
  "recaptchaSiteKey": ""
}